module.exports = __webpack_public_path__ + "d319871d79746588dc76129abc612ed4.svg";